import { POST } from "../../index";

export const selectStation = (param) => POST("/v2/Station/selectStation", param);
export const insertStation = (param) => POST("/v2/Station/insertStation", param);
export const updateStation = (param) => POST("/v2/Station/updateStation", param);
export const deleteStation = (param) => POST("/v2/Station/deleteStation", param);
